import { graphql } from "gql";

const EDIT_USER_AVATAR_MUTATION = graphql(`
  mutation EditUserAvatar($base64Avatar: String!, $contentType: String!) {
    editMe(
      input: {
        avatar: { base64Avatar: $base64Avatar, contentType: $contentType }
      }
    ) {
      id
      avatarUrl
    }
  }
`);

export default EDIT_USER_AVATAR_MUTATION;
